import { mapActions, mapState } from 'vuex';
import ApiActions from '@/modules/api-actions';
import { EVENTS as HW_EVENTS } from '@/events/hardware';
import { getRandomInt } from '@/modules/utils';

const parseActionFromText = result => {
  try {
    const url = new URL(result);
    const { hostname, pathname, search } = url;
    if (!hostname.endsWith('tg3ds.com') && !hostname.endsWith('tg3ds.com.cn')) return {};

    if (pathname.startsWith('/share/') && pathname.endsWith('/garment-display')) {
      return {
        type: 'garment',
        payload: result,
      };
    }
    if (pathname.endsWith('/links')) {
      const params = new URLSearchParams(search);
      const dataCount = parseInt(params.get('dc'), 10) || 0;
      const type = params.get('at');
      if (!type || !dataCount) return {};

      const payload = [];
      for (let i = 0; i < dataCount; i += 1) {
        payload.push(params.get(`d${i}`));
      }
      return {
        type,
        payload: payload.length === 1 ? payload[0] : payload,
      };
    }
    return {};
  } catch (e) {
    const prefix = result.split(':', 2);
    if (!Array.isArray(prefix)) return {};

    if (prefix[0] === '_tg3ds') {
      return {
        type: prefix[1],
        payload: result.replace(`${prefix[0]}:${prefix[1]}:`, ''),
      };
    }

    return {};
  }
};

const determineCharPosition = base => (base[0].charCodeAt(0) % 9) + 1;

const makeEncodedStoreId = storeId => { // eslint-disable-line
  const extra = getRandomInt(0, 10);
  const base = window.btoa(storeId).split('');
  const charPosition = determineCharPosition(base);
  base.splice(charPosition, 0, extra);
  return base.join('');
};

const decodeStoreId = encoded => {
  const base = encoded.split('');
  const charPosition = determineCharPosition(base);
  base.splice(charPosition, 1);
  return window.atob(base.join(''));
};

const handleQrScan = {
  mounted() {
    this.$events.on(HW_EVENTS.QRCODE_SUCCESS, this.onQrCodeSuccess);
    this.$events.on(HW_EVENTS.QRCODE_ERROR, this.onQrCodeError);
  },
  beforeDestroy() {
    this.$events.off(HW_EVENTS.QRCODE_SUCCESS, this.onQrCodeSuccess);
    this.$events.off(HW_EVENTS.QRCODE_ERROR, this.onQrCodeError);
  },
  data: () => ({
    showWelcomePrompt: false,
  }),
  methods: {
    ...mapActions('app', ['displayGarment', 'launchQrScan', 'cancelQrScan', 'setStoreConfigs']),
    async onQrCodeSuccess(result) {
      console.log('onQrCodeSuccess result', result);
      this.cancelQrScan();
      await this.handleIncomingAction(parseActionFromText(result));
    },
    onQrCodeError(error) {
      console.log('onQrCodeError', error);
    },
    async handleIncomingAction({ type, payload }) {
      console.log('handleIncomingAction', type, payload);
      if (type === 'garment') {
        this.displayGarment(payload);
      } else if (type === 'remote_signin' && payload) {
        this.$events.startLoading();
        try {
          await ApiActions.user.remoteSignIn(payload);
        } catch (e) {
          console.log(e.message);
        } finally {
          this.$events.stopLoading();
        }
      } else if (type === 'store' && payload) {
        await this.applyStoreSettings(payload);
      }
    },
    async handleDeepLink(link) {
      console.log('Got deep link', link);
      await this.handleIncomingAction(parseActionFromText(link));
    },
    async applyStoreSettings(encoded) {
      const storeId = decodeStoreId(encoded);
      if (!storeId) {
        console.log('invalid payload', encoded);
        return;
      }
      this.$events.startLoading();
      try {
        let configs = await ApiActions.mtm.getStoreConfigs(storeId);
        configs = { ...configs , store_id: storeId }
        console.log('fetch getStoreConfigs', configs);
        this.setStoreConfigs(configs);
        this.showWelcomePrompt = true;
      } catch (e) {
        console.log(e.message);
      } finally {
        this.$events.stopLoading();
      }
    },
  },
  computed: {
    ...mapState('app', ['isScanningQr']),
  },
  watch: {
  },
};

export default handleQrScan;
